module.exports = __webpack_public_path__ + "static/media/ratibhai.393ee3a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ratibhai.jpg
// module id = 1195
// module chunks = 0